import React, { Fragment, useEffect } from 'react';
import './cart-standalone-tabs.scss';

import SidebarTabBar from '../../../../components/sidebar-tab-bar/sidebar-tab-bar';
import { useCartStandaloneProvider } from '../cart-standalone-provider/cart-standalone-provider';
import useStandaloneCartTabs from '../../../../hooks/useStandaloneCartTabs';

const CartStandaloneTabs = () => {
      const { onChangeTab, selectedTab } = useCartStandaloneProvider();

      const { tabs } = useStandaloneCartTabs();

      useEffect(() => {
            onChangeTab(tabs?.[0].key)
      }, []);

      useEffect(() => {
            if (!tabs.some(tab => tab.key === selectedTab)) {
                  onChangeTab(tabs?.[0].key)
            }
      }, [JSON.stringify(tabs)]);

      return (
            <div className={`cart-standalone-tabs-container ${selectedTab}`}>
                  <SidebarTabBar
                        barStyle={{
                              marginLeft: 16,
                              marginRight: 16,
                        }}
                        tabs={tabs}
                        onPressTab={() => {}}
                        selectedTab={selectedTab}
                  />
                  <div className='tabs-wrapper'>
                        {tabs.map(({component, key}) => (
                              <Fragment key={key}>
                                    {component()}
                              </Fragment>
                        ))}
                  </div>
            </div>
      )
}

export default CartStandaloneTabs;
